import { Button } from "@/components/ui/button";

export function NoSearchResults({
  message,
  onClearSearch,
}: {
  message: string;
  onClearSearch: () => void;
}) {
  return (
    <div className="flex w-full flex-col items-center justify-start py-8">
      <p className="text-gray-500">{message}</p>
      <Button
        variant="outline"
        size="sm"
        onClick={onClearSearch}
        className="mt-2"
      >
        Clear search
      </Button>
    </div>
  );
}
